import { IObjectAudit, ICompositeFileInfo } from "../../../models"

export interface IBadge {
    Id: string
    Name: string
    Style: EBadgeStyle
    Color: string
    WorkflowId: string
    Active: boolean
    AutoAssign: boolean
    Licenses: IBadgeFileInfo[]
    Certifications: IBadgeFileInfo[]
    Files: IBadgeFileInfo[]
    TestingSkills: IBadgeFileInfo[]
    Checklists: IBadgeFileInfo[]
    AutoCreateCompositeFile: boolean
    CompositeFileInfo: ICompositeFileInfo
    Deleted: boolean
    TicksSinceChange: number
    ObjectAudit: IObjectAudit
}

export enum EBadgeStyle {
    Default = 0
}

export interface IBadgeFileInfo {
    FileId: string
    FileVersion: number
    Type: EBadgeFileType
    SubTypeId: string
    SubTypeName: string
}

export enum EBadgeFileType {
    License = 0,
    Certification = 1,
    File = 2,
    TestSkill = 3,
    Checklist = 4
}